// extracted by mini-css-extract-plugin
module.exports = {"container":"_27Lv73B_"};